import React, { useState } from "react";
import "../style/Contact.css";
import LeaveMessage from "./LeaveMessage";

const Contact = () => {
  const [showForm, setShowForm] = useState(false);

  return (
    <>
      <div id="searchResults"></div>
<LeaveMessage />
      

      {/* ---------------- HEADING ---------------- */}
      <section>
        <div className="heading-section">
          <h2>CONTACT US</h2>
        </div>
      </section>

      {/* ---------------- CONTACT SECTION ---------------- */}
      <section className="contact-section">
        {/* Contact Form */}
        <div className="contact-form">
          <h2>CONTACT</h2>
          <p className="description">
            If you have questions or suggestions, please leave us a message, we
            will reply you as soon as we can!
          </p>
          <form>
            <strong>Email</strong>
            <input type="email" placeholder="Example@email.com" required />
            <strong>Phone Number</strong>
            <input type="text" placeholder="+91 " />
            <strong>Message</strong>
            <textarea placeholder="* Message....." rows="6" required></textarea>
            <button type="submit">SUBMIT</button>
          </form>
        </div>

        {/* Contact Info */}
        <div className="contact-info">
          <h3>A-OK MOTOR (INDIA) PVT. LTD</h3>
          <p>
            <strong>Tel:</strong> +91 7942963398
          </p>
          <p>
            <strong>Web:</strong> a-okmotors.in
          </p>
          <p>
            <strong>Email:</strong><br />
            <a href="mailto:inquiry@a-okmotorindia.com">inquiry@a-okmotorindia.com</a><br />
            <a href="mailto:sales@skylifestyle.in">sales@skylifestyle.in</a><br />
            <a href="mailto:Sales.2@skylifestyle.in">sales.2@skylifestyle.in</a>
          </p>

          <p>
            <strong>Headquarter Address:</strong> BF 9-12, Krishna Complex,
            Opp. Essar Petrol Pump, Yellow Lime Hotel Complex, Sarkhej Sanand
            Road, Sarkhej, Ahmedabad-382210.
          </p>
          <div className="map">
            <iframe
              title="A-OK India Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3672.014654137967!2d72.500274!3d23.010516!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e84f62a5b61f7%3A0xabc123!2sA-OK%20India!5e0!3m2!1sen!2sin!4v1700000000000"
              allowFullScreen
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
